import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { CreateVehicleForm } from '../api/vehicle.data.ts'
import { createVehicle } from '../api/vehicle.service.ts'

export interface UseCreateVehicleOptions {
  onSuccess?: (vehicleName: string) => void
  onError?: (error: Error) => void
}

export function useCreateVehicle(options: UseCreateVehicleOptions) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (formData: CreateVehicleForm) => {
      // Form data now includes siteId, no need to add fleetId
      return createVehicle(formData)
    },
    onSuccess: async (_, formData) => {
      // Invalidate any vehicle-related queries if they exist
      await queryClient.invalidateQueries({
        queryKey: ['vehicles']
      })

      // Call the success callback if provided
      options.onSuccess?.(formData.vehicleName)
    },
    onError: (error: Error) => {
      // Call the error callback if provided
      options.onError?.(error)
    }
  })
}
